import { useState } from "react";
import { cn } from "@/lib/utils";

const DEFAULT_LOGO = "/images/ikimina-logo.jpg";

function getStoredLogo(): string {
  try {
    return localStorage.getItem("cooperativeLogo") || DEFAULT_LOGO;
  } catch {
    return DEFAULT_LOGO;
  }
}

type LogoSize = number | "xs" | "sm" | "md" | "lg" | "xl";

function resolveSize(size: LogoSize): number {
  if (typeof size === "number") return size;
  const map: Record<string, number> = {
    xs: 32,
    sm: 40,
    md: 44,
    lg: 72,
    xl: 80,
  };
  return map[size] ?? 44;
}

interface CooperativeLogoProps {
  size?: LogoSize;
  className?: string;
  imgClassName?: string;
  circular?: boolean;
}

export function CooperativeLogo({
  size = "md",
  className,
  imgClassName,
  circular = true,
}: CooperativeLogoProps) {
  const [failed, setFailed] = useState(false);
  const px = resolveSize(size);

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden",
        circular ? "rounded-full" : "rounded-lg",
        className,
      )}
      style={{ width: px, height: px }}
    >
      {failed ? (
        <span
          className="text-xs font-bold text-green-700 flex items-center justify-center bg-green-50 w-full h-full"
          style={{ fontSize: Math.max(px * 0.25, 10) }}
        >
          CEIK
        </span>
      ) : (
        <img
          src={getStoredLogo()}
          alt="Cooperative logo"
          className={cn(
            "w-full h-full object-cover",
            circular && "rounded-full",
            imgClassName,
          )}
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}

export function getCooperativeLogoSrc(): string {
  try {
    return localStorage.getItem("cooperativeLogo") || DEFAULT_LOGO;
  } catch {
    return DEFAULT_LOGO;
  }
}
